var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_190",
    "data-name": "\\uADF8\\uB8F9 190",
    transform: "translate(-989 -1379)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_55",
    "data-name": "\\uC0AC\\uAC01\\uD615 55",
    transform: "translate(989 1379)",
    fill: "#fff",
    stroke: "#e4e4e4",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 36,
    height: 36,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_28",
    "data-name": "\\uC120 28",
    y1: 20,
    x2: 20,
    transform: "translate(999 1389)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_29",
    "data-name": "\\uC120 29",
    x1: 20,
    y1: 20,
    transform: "translate(999 1389)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveIcon);
export default __webpack_public_path__ + "static/media/remove_icon.5f90117b88f348061e7915d74e4dc8ba.svg";
export { ForwardRef as ReactComponent };